export const OAUTH_SCOPE: string = 'mcp:connect';
export const OAUTH_TOKEN_EXCHANGE_GRANT_TYPE: string = 'urn:ietf:params:oauth:grant-type:token-exchange';
export const OAUTH_ACCESS_TOKEN_TYPE: string = 'urn:ietf:params:oauth:token-type:access_token';
export const OAUTH_MCP_CLIENT_ID: string = 'level-access-mcp-server';

export const ON_BEHALF_OF_TOKEN_HEADER: string = 'x-on-behalf-of-token';
export const ON_BEHALF_OF_TOKEN_AUDIENCE: string = 'urn:levelaccess:platform-public-api';
export const ON_BEHALF_OF_TOKEN_TYPE: string = 'obo+jwt';
export const ON_BEHALF_OF_ALLOWED_CLIENTS: string[] = [OAUTH_MCP_CLIENT_ID];
export const ON_BEHALF_OF_TOKEN_ROUTES: string[] = ['/api/v1/public', '/api/v2/public'];
/** Where, below the authorization server's address, the pages of an authorization in progress live. */
export const OAUTH_INTERACTION_PATH: string = 'interaction';
/** A consent decision must carry this header: a web page of another origin can't add a custom header without a preflight. */
export const OAUTH_CONSENT_REQUESTED_WITH_HEADER: string = 'x-requested-with';
export const OAUTH_CONSENT_REQUESTED_WITH_VALUE: string = 'oauth-consent';

/** The query parameters of the app's error page: why the connection could not continue, and the error code of the authorization server. */
export const OAUTH_ERROR_REASON_PARAM: string = 'reason';
export const OAUTH_ERROR_CODE_PARAM: string = 'error';

export enum OAuthErrorReason {
  linkNotValid = 'link_not_valid',
  requestNotRecognized = 'request_not_recognized',
  serverError = 'server_error',
  declined = 'declined',
  generic = 'generic',
}

/** The only error codes that are passed on to the error page and shown there: anything else is dropped. */
export const OAUTH_ERROR_CODES = [
  'invalid_redirect_uri',
  'invalid_client',
  'invalid_client_metadata',
  'unauthorized_client',
  'invalid_request',
  'invalid_request_uri',
  'invalid_request_object',
  'invalid_scope',
  'invalid_target',
  'unsupported_response_type',
  'server_error',
  'temporarily_unavailable',
  'access_denied',
] as const;

export type OAuthErrorPageCode = (typeof OAUTH_ERROR_CODES)[number];

export const MCP_OAUTH_INITIATED_EVENT: 'mcp oauth initiated' = 'mcp oauth initiated';
export const MCP_OAUTH_CONSENT_EVENT: 'mcp oauth consent' = 'mcp oauth consent';
export const MCP_OAUTH_COMPLETED_EVENT: 'mcp oauth completed' = 'mcp oauth completed';

export enum OAuthConsentStatus {
  pending = 'pending',
  approved = 'approved',
  denied = 'denied',
}

export enum OAuthAmplitudeEvent {
  exchangeRefused = 'mcp oauth exchange refused',
}

export enum $oauthProviderRecord {
  _id = '_id',
  kind = 'kind',
  payload = 'payload',
  uid = 'uid',
  grantId = 'grantId',
  accountId = 'accountId',
  clientName = 'clientName',
  redirectHost = 'redirectHost',
  expiresAt = 'expiresAt',
}

export enum $oauthConsentRequest {
  _id = '_id',
  requestId = 'requestId',
  uid = 'uid',
  clientId = 'clientId',
  clientName = 'clientName',
  redirectUris = 'redirectUris',
  scope = 'scope',
  resource = 'resource',
  tenantId = 'tenantId',
  tenantDomain = 'tenantDomain',
  status = 'status',
  userId = 'userId',
  approvalId = 'approvalId',
  decidedAt = 'decidedAt',
  usedAt = 'usedAt',
  expiresAt = 'expiresAt',
  createdAt = 'createdAt',
  updatedAt = 'updatedAt',
}

export enum $oauthClientConsent {
  _id = '_id',
  userId = 'userId',
  tenantId = 'tenantId',
  clientId = 'clientId',
  clientName = 'clientName',
  scope = 'scope',
  expiresAt = 'expiresAt',
  createdAt = 'createdAt',
  updatedAt = 'updatedAt',
}
